import type { ReactNode } from 'react';

import { cx } from './cx';

/**
 * The top of a settings section or a report: the title, one line saying what it is for, and
 * whatever the page is driven by on the right.
 *
 * The description is not decoration. A tab strip could get away with one word per tab
 * because there were only ever ten of them on one screen; a page reached from a sidebar has
 * to say what it is before somebody changes something on it.
 */
export function PageHeader({
  title,
  description,
  actions,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <header className={cx('flex items-start justify-between gap-4', className)}>
      <div className="min-w-0">
        <h1 className="text-page font-semibold tracking-[-0.01em] leading-[1.2] m-0">{title}</h1>
        {description ? <p className="text-nav text-ink-3 mt-1 mb-0">{description}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
    </header>
  );
}
